import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";

const SFChip = ({ children, ...props }) => {
  return <Chip label={children} {...props} />;
};

SFChip.propTypes = {
  /* The Avatar element to display. */
  avatar: PropTypes.element,
  /* If true, the chip will appear clickable, and will raise when pressed, even if the onClick prop is not defined. If false,
   the chip will not appear clickable, even if onClick prop is defined. This can be used, for example, along with the component 
   prop to indicate an anchor Chip is clickable. Note: this controls the UI and does not affect the onClick event.	*/
  clickable: PropTypes.bool,
  /* The color of the component. It supports the default mui colors : default,primary,secondary,error,info,success,warning or any color
  added to the theme palette. */
  color: PropTypes.string,
  /*The component used for the root node. Either a string to use a HTML element or a component. 
  e.g. component={<NavLink/>} component={"div"} etc. */
  component: PropTypes.elementType,
  /* Override the default delete icon element. Shown only if onDelete is set.*/
  deleteIcon: PropTypes.element,
  /* If true, the component is disabled. */
  disabled: PropTypes.bool,
  /* Icon	element.	*/
  icon: PropTypes.element,
  /* The content of the component. */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /* Callback fired when the delete icon is clicked. If set, the delete icon will be shown. */
  onDelete: PropTypes.func,
  /* The size of the chip */
  size: PropTypes.oneOf(["medium", "small"]),
  /* The prop that allows style ovverides */
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.bool]),
  /* The variant to use. */
  variant: PropTypes.oneOf([
    "filled",
    "outlined",
    "filterChip",
    "popoverFilterChip",
  ]),
};

export default SFChip;
